<template>
  <div>
    <h1>Participant Visits</h1>
    
    <form ref="form" @submit.stop.prevent="handleSubmit">
        <div class="row">
          <div class="col-sm">
              <b-table hover small responsive
                :fields="fields"
                :items="visits">
                <template v-slot:cell(actions)="row">
                  <b-button size="sm" @click="purge(row.item)" class="mr-1">
                    purge visit
                  </b-button>
                </template>
              </b-table>
          </div>
        </div>
      </form>
    </div>
</template>

<script>
  import axios from 'axios';
  import axiosRetry from 'axios-retry';

  axiosRetry(axios, { retries: 3 });

  export default {
    props: [
      'id'
    ],
    title:  'Participant Visits',
    data: () => ({
      fields: [
        {key: 'eventDate', sortable: false, label: 'Event Date'},
        {key: 'eventUuid', sortable: false, label: 'Event Id'},
        {key: 'eventType', sortable: false, label: 'Type'},
        {key: 'actionType', sortable: false, label: 'Action'},
        {key: 'ehrCode', sortable: false, label: 'EHR'},
        {key: 'fhvProviderName', sortable: false, label: 'Provider'},
        {key: 'lastName', sortable: false, label: 'Last Name'},
        {key: 'actions', label: 'Actions'}
      ],

      isLoading: true,

      visits: [],

      options: {
          format: 'YYYY-MM-DD',
          useCurrent: false,
      },
    }),

    watch: {
      editedItem() {
        this.$v.$reset()
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      fetchVisits() {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/admin/participant/visits/${this.id}`)
            .then(response => {
                this.visits = response.data;
            })
             .catch(error => { // The first request fails
                 error !== undefined
                 console.log("an error has occurred")
                 this.$router.push('home')
            })
      },

      initialize () {
          this.fetchVisits()
      },

      editItem (item) {
        console.log(item)
        this.editedIndex = this.providers.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$bvModal.show('modal-crud')
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      purge(visit) {
        this.$bvModal.msgBoxConfirm('Are you sure you wish to purge this visit from FHV?')
          .then(value => {
            if (value) {
              console.log("delete it")
              axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/participant/purge/`, visit)
                .then(response => { 
                  this.$bvToast.toast('Purge Request Saved', {
                    title: 'Status',
                    toaster: 'b-toaster-top-center',
                    solid: true,
                    variant: 'success',
                    appendToast: true
                  })                
              })
             .catch(error => { // The first request fails
                 error !== undefined
                 console.log("an error has occurred")
                 this.$router.push('home')
              })
            }
          })
          .catch(err => {
            // An error occurred
          })
      }
    }
  }
</script>